<template>
  <div class="top-mobile-search">
    <div class="row">
      <div class="col-md-12">
        <form class="mobile-search">
          <VideoTags />
          <!-- <VideoSearch /> -->
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    VideoTags: () => import('@/components/video/VideoTags'),
    // VideoSearch: () => import('@/components/video/VideoSearch'),
  },
};
</script>
